import { createStyles, makeStyles, Theme } from '@material-ui/core';

const MediaPreviewStyles = makeStyles(({ palette, breakpoints }: Theme) => createStyles({
  image: {
    maxWidth: '100%',
    maxHeight: '100%',
    background: '#FFF',
  },
  wrapper: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    height: '65vh',
    width: '90vw',
    maxWidth: '100%',
    maxHeight: '100%',
    margin: 'auto',
    justifyContent: 'space-between',
    overflow: 'unset',
    textAlign: 'center',
    [breakpoints.down('sm')]: {
      padding: 'unset',
    },
  },
  header: {
    color: '#FFF',
    padding: '20px 24px 20px 24px',
  },
  title: {
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: '#FFF',
    fontSize: 24,
    letterSpacing: 0.31,
    fontFamily: 'Montserrat',
    fontWeight: 500,
    paddingBottom: 10,
    [breakpoints.down('xs')]: {
      fontSize: 16,
    },
  },
  text: {
    fontSize: 16,
  },
  uploaded: {
    fontSize: 16,
  },
  backdrop: {
    background: 'rgba(0,0,0,0.85)',
  },
  paperRoot: {
    background: 'transparent',
    boxShadow: 'unset',
    height: '100%',
    [breakpoints.down('md')]: {
      width: '100%',
      margin: 'unset',
      maxHeight: 'unset',
    },
  },
  mediaPreviewContainer: {
    width: '100%',
    height: '100%',
    maxWidth: 'calc(100% - 140px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflowX: 'hidden',
    margin: 'auto',
  },
  noselect: {
    WebkitTouchCallout: 'none',
    WebkitUserSelect: 'none',
    KhtmlUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none',
    userSelect: 'none',
  },
  playerWrapper: {
    maxWidth: '100%',
    height: '100%',
  },
}), { name: 'CommonMediaPreview' });

export default MediaPreviewStyles;
